export default __webpack_public_path__ + "static/media/No_Card_Selet_Img_252px@3x.2868b245.png";